import { render } from "./field_settings.vue?vue&type=template&id=28d9918c"
import script from "./field_settings.vue?vue&type=script&lang=js"
export * from "./field_settings.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/gosign-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__